import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass, nodeTone } from '../../nodeCatalog'

const TYPE = 'httpRequest'
const Icon = nodeIcon(TYPE)

const HttpRequestNode: React.FC<NodeProps> = ({ data, selected }) => {
  const method = data.http_request_config?.method || 'POST'
  const urlDisplay = data.http_request_config?.url ? '...' : 'no URL'
  const subtitle = `${method} ${urlDisplay}`

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle type="target" position={Position.Top} className={nodeHandleClass(TYPE)} />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>HTTP</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'HTTP Request'}</p>
        </div>
      </div>
      <p className="mt-1 text-xs text-muted-foreground pl-10 capitalize">{subtitle}</p>
      {data._upstreamEnrichmentFields?.length > 0 && (
        <div className="mt-1.5 flex items-center gap-1 pl-10">
          <div className={`w-2 h-2 rounded-full animate-pulse ${nodeTone('enrichContacts').solid}`} />
          <span className={`text-[10px] font-medium ${nodeTextClass('enrichContacts')}`}>
            {data._upstreamEnrichmentFields.length} enrichment fields
          </span>
        </div>
      )}
      <Handle type="source" position={Position.Bottom} className={nodeHandleClass(TYPE)} />
    </div>
  )
}

export default memo(HttpRequestNode)
